var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 27,
    viewBox: "0 0 68 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 4.60229,
    width: 4.90909,
    height: 17.7955,
    rx: 2.45455,
    fill: "#6ECAF0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21.1704,
    y: 5.82953,
    width: 4.90909,
    height: 15.3409,
    rx: 2.45455,
    fill: "#6ECAF0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 41.7273,
    y: 4.60229,
    width: 4.90909,
    height: 17.7955,
    rx: 2.45455,
    fill: "#6ECAF0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 62.8977,
    y: 5.82953,
    width: 4.90909,
    height: 15.3409,
    rx: 2.45455,
    fill: "#6ECAF0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 52.1592,
    width: 5.21591,
    height: 27,
    rx: 2.60795,
    fill: "#00EFFE"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 30.9885,
    y: 7.36365,
    width: 5.82955,
    height: 12.2727,
    rx: 2.91477,
    fill: "#00EFFE"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 10.4319,
    width: 5.21591,
    height: 27,
    rx: 2.60795,
    fill: "#00EFFE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.cacc526d4bc1f5da3670e2efb045ef38.svg";
export { ForwardRef as ReactComponent };